import { createFileRoute } from "@tanstack/react-router";
import { Download, FileText } from "lucide-react";
import { useSiteSection } from "@/hooks/useSiteContent";
import { siteFileUrl } from "@/hooks/useSiteData";

export const Route = createFileRoute("/downloads")({
  head: () => ({
    meta: [
      { title: "Área de downloads — Contato Internet" },
      {
        name: "description",
        content:
          "Baixe contratos, regulamentos e termos de uso da Contato Internet em PDF.",
      },
      { property: "og:title", content: "Área de downloads — Contato Internet" },
      {
        property: "og:description",
        content: "Contratos, regulamentos e termos de uso para download.",
      },
    ],
  }),
  component: DownloadsPage,
});

function DownloadsPage() {
  const downloads = useSiteSection("downloads");
  const items = (downloads.items ?? []).filter((it) => it.name && it.fileUrl);

  return (
    <div className="mx-auto max-w-4xl px-5 py-12 sm:py-16">
      <h1 className="text-2xl font-extrabold uppercase tracking-tight text-primary sm:text-3xl">
        {downloads.title || "Área de downloads"}
      </h1>
      {downloads.subtitle && (
        <p className="mt-2 text-sm text-muted-foreground">{downloads.subtitle}</p>
      )}

      <div className="mt-8 overflow-hidden rounded-2xl border border-border">
        {items.length === 0 ? (
          <p className="p-8 text-center text-sm text-muted-foreground">
            Nenhum arquivo disponível no momento.
          </p>
        ) : (
          <ul className="divide-y divide-border">
            {items.map((item, i) => {
              const url = siteFileUrl(item.fileUrl);
              return (
                <li
                  key={`${item.name}-${i}`}
                  className="flex flex-wrap items-center gap-3 px-4 py-4 sm:gap-4 sm:px-6"
                >
                  <div className="grid size-10 shrink-0 place-items-center rounded-xl bg-primary/10 text-primary">
                    <FileText className="size-5" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-semibold text-foreground sm:text-base">
                      {item.name}
                    </p>
                    <p className="mt-0.5 text-xs text-muted-foreground">
                      {[item.fileType?.toUpperCase(), item.sizeLabel].filter(Boolean).join(" · ")}
                    </p>
                  </div>
                  {url && (
                    <a
                      href={url}
                      target="_blank"
                      rel="noreferrer"
                      download
                      data-track-cta={`downloads:${item.name}`}
                      className="inline-flex shrink-0 items-center gap-2 rounded-full border border-input px-4 py-2 text-sm font-semibold transition hover:bg-accent"
                    >
                      <Download className="size-4" /> download
                    </a>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
